export default __webpack_public_path__ + "static/zu2-39efa5c58d92e8e6838685cce5466ace.png";